<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.voucherTypeList.push"
    :is-show-search-input="true"
    search-placeholder="输入代金券类型名称进行搜索"
  >
    <template slot="header-item">
      <v-select-voucher-issue-type
        label="发放方式"
        :multiple="true"
        v-model="queryList.issue_types"
        size="small"
        @input="handleIssueTypesChange"
      />
    </template>
    <el-table-column label="ID" prop="id" width="70"/>
    <el-table-column label="代金券类型名称" prop="voucher_type_name"/>
    <el-table-column label="面额（元）">
      <template v-slot="{ row }">{{ row.amount_in_cents | toYuan }}</template>
    </el-table-column>
    <el-table-column label="小程序售价（元）" width="140">
      <template v-slot="{ row }">
        <template v-if="row.issue_type === 5">{{ row.sale_price_in_cents | toYuan }}</template>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <el-table-column label="购买范围" width="130">
      <template v-slot="{ row }">
        <el-tag
          v-if="row.issue_type === 5"
          :type="findVoucherPurchaseScopeItem(row.purchase_scope).tagType"
          size="small"
        >{{ findVoucherPurchaseScopeItem(row.purchase_scope).name }}</el-tag>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <el-table-column label="有效期">
      <template v-slot="{ row }">
        <template v-if="row.expire_mode === 1 && row.fixed_expire_time">
          {{ row.fixed_expire_time | timeToYmdHi }} 过期
        </template>
        <template v-else>{{ row.valid_duration_seconds | formatDuration }}</template>
      </template>
    </el-table-column>
    <el-table-column label="发放方式">
      <template v-slot="{ row }">
        <span v-for="state in findVoucherIssueType(row.issue_type)" :key="state.value">
          {{ state.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="唯一性" width="90">
      <template v-slot="{ row }">
        <el-tag :type="row.is_unique ? 'warning' : 'success'" size="small">
          {{ row.is_unique ? '限领一张' : '可重复' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="叠加使用" width="90">
      <template v-slot="{ row }">
        <el-tag :type="row.is_stackable ? 'success' : 'warning'" size="small">
          {{ row.is_stackable ? '可叠加' : '不可叠加' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="活动时间" width="200">
      <template v-slot="{ row }">
        <template v-if="[1, 4, 5].includes(row.issue_type) && row.start_time">
          {{ row.start_time | timeToYmdHi }} ~ {{ row.end_time | timeToYmdHi }}
        </template>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <el-table-column label="适用套餐" width="160">
      <template v-slot="{ row }">
        <span v-if="row.card_charge_types && row.card_charge_types.length">
          <el-tag
            v-for="ct in row.card_charge_types.slice(0, 3)"
            :key="ct.id"
            size="mini"
            type="info"
            style="margin-right: 2px;"
          >{{ ct.card_charge_type_name }}</el-tag>
          <el-tag v-if="row.card_charge_types.length > 3" size="mini" type="info">
            +{{ row.card_charge_types.length - 3 }}
          </el-tag>
        </span>
        <span v-else class="info-color">全部套餐</span>
      </template>
    </el-table-column>
    <el-table-column label="购买课次券" width="150">
      <template v-slot="{ row }">
        <span v-if="row.card_ticket_types && row.card_ticket_types.length">
          <el-tag
            v-for="tt in row.card_ticket_types.slice(0, 2)"
            :key="tt.id"
            size="mini"
            type="info"
            style="margin-right: 2px;"
          >{{ tt.card_ticket_type_name }}</el-tag>
          <el-tag v-if="row.card_ticket_types.length > 2" size="mini" type="info">
            +{{ row.card_ticket_types.length - 2 }}
          </el-tag>
        </span>
        <span v-else class="info-color">--</span>
      </template>
    </el-table-column>
    <el-table-column label="使用规则" prop="rule" show-overflow-tooltip min-width="120"/>
    <v-column-time/>
    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">

        <v-list-button :to="RouteConfig.voucherTypeEdit.to(row.id)"/>

        <v-list-button
          name="删除"
          icon="bin"
          @click="handleDelete(row)"
          :is-loading="isDeleting[row.id]"
          message="确定要删除此类型吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>


    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`voucher-type-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>代金券类型名称</span>
              <span>{{ v.voucher_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>面额（元）</span>
              <span>{{ v.amount_in_cents | toYuan }}</span>
            </div>

            <div class="list-item-detail" v-if="v.issue_type === 5">
              <span>小程序售价（元）</span>
              <span>{{ v.sale_price_in_cents | toYuan }}</span>
            </div>

            <div class="list-item-detail" v-if="v.issue_type === 5">
              <span>购买范围</span>
              <el-tag
                :type="findVoucherPurchaseScopeItem(v.purchase_scope).tagType"
                size="small"
              >{{ findVoucherPurchaseScopeItem(v.purchase_scope).name }}</el-tag>
            </div>

            <div class="list-item-detail">
              <span>有效期</span>
              <span v-if="v.expire_mode === 1 && v.fixed_expire_time">{{ v.fixed_expire_time | timeToYmdHi }} 过期</span>
              <span v-else>{{ v.valid_duration_seconds | formatDuration }}</span>
            </div>

            <div class="list-item-detail">
              <span>发放方式</span>
              <span v-for="state in findVoucherIssueType(v.issue_type)" :key="state.value">
                {{ state.name }}
              </span>
            </div>

            <div class="list-item-detail">
              <span>唯一性</span>
              <span>{{ v.is_unique ? '每人限领一张' : '可重复拥有' }}</span>
            </div>

            <div class="list-item-detail">
              <span>叠加使用</span>
              <span>{{ v.is_stackable ? '可叠加' : '不可叠加' }}</span>
            </div>

            <div class="list-item-detail" v-if="[1, 4, 5].includes(v.issue_type)">
              <span>活动时间</span>
              <span>{{ v.start_time | timeToYmdHi }} ~ {{ v.end_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>适用套餐</span>
              <span v-if="v.card_charge_types && v.card_charge_types.length">
                <template v-for="ct in v.card_charge_types">{{ ct.card_charge_type_name }} </template>
              </span>
              <span v-else class="info-color">全部套餐</span>
            </div>

            <div class="list-item-detail" v-if="v.issue_type === 4">
              <span>购买课次券</span>
              <span v-if="v.card_ticket_types && v.card_ticket_types.length">
                <template v-for="tt in v.card_ticket_types">{{ tt.card_ticket_type_name }} </template>
              </span>
              <span v-else class="info-color">--</span>
            </div>

            <div class="list-item-detail" v-if="v.rule">
              <span>使用规则</span>
              <span>{{ v.rule }}</span>
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.voucherTypeEdit.to(v.id)"/>

              <v-list-button
                name="删除"
                icon="bin"
                @click="handleDelete(v)"
                :is-loading="isDeleting[v.id]"
                message="确定要删除此类型吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index, destroy } from '@/api/voucher-type';
import { findVoucherIssueType } from '@/enums/voucherIssueTypes';
import { findVoucherPurchaseScopeItem } from '@/enums/voucherPurchaseScopes';

export default {
  name: RouteConfig.voucherTypeList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      issue_types: [],
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findVoucherIssueType,
    findVoucherPurchaseScopeItem,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    refresh() {
      // 将数组转为逗号分隔字符串，确保 URL 路由同步兼容
      const query = { ...this.queryList };
      query.issue_types = query.issue_types.length ? query.issue_types.join(',') : undefined;
      RouteConfig.voucherTypeList.push(query);
    },
    handleIssueTypesChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async handleDelete({ id, update_time }) {
      if (this.isDeleting[id]) return;
      if (!id) return this.$message.warning('缺少代金券类型 ID，无法删除！');
      if (!Number.isInteger(update_time) || update_time < 0) return this.$message.warning('缺少代金券类型信息，无法删除！');

      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id, update_time);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
};
</script>
